import React from 'react';
import styles from './penalizedFilterLabel.module.css';
import { PENALIZED_FILTERS_LABEL_TEST_ID } from '../../constants';

type PenalizedFilterLabelProps = {
  children: React.ReactNode;
};

const PenalizedFilterLabel: React.FC<PenalizedFilterLabelProps> = ({
  children,
}) => (
  <div className={styles.label} data-testid={PENALIZED_FILTERS_LABEL_TEST_ID}>
    {children}
  </div>
);

export default PenalizedFilterLabel;
